import DeleteIcon from '../../assets/icons/DeleteIcon'

interface SelectCardProps {
  title: string
  description?: string
  showRemove?: boolean
  removeFn?: () => void
  addFn?: () => void
}

const SelectCard = ({
  title,
  description,
  showRemove,
  removeFn,
  addFn,
}: SelectCardProps) => {
  return (
    <div
      className="flex border w-fit items-center bg-gray-50 p-1 rounded "
      title={description}
    >
      <p onClick={addFn} className={`${addFn ? 'cursor-pointer' : ''} whitespace-nowrap`}>
        {title}
      </p>
      {showRemove ? (
        <span className="pl-2 cursor-pointer" onClick={removeFn}>
          <DeleteIcon />
        </span>
      ) : null}
    </div>
  )
}

export default SelectCard
